import * as React from 'react';
import { cn } from '@repo/ui/lib/utils';

export const Progress: React.FC<{
  className?: string;
  indicatorClass?: string;
}> = ({ className, indicatorClass }) => (
  <div
    className={cn('w-full bg-secondary', className)}
    data-testid="loading-progress"
  >
    <div
      className={cn('bg-primary h-2 animate-progress', indicatorClass)}
    ></div>
  </div>
);
